import { AbstractQuery } from 'src/models/query';

export class GetAllUsersWithAccessToTheModuleForTheUserFilterQuery extends AbstractQuery {
	name = 'IFS_DesktopModule_Core_Query_Queries_GetAllUsersWithAccessToTheModuleForTheUserFilterQuery';
	page = 1;
	subscribeForUpdates = false;
	constructor(module: string) {
		super();
		this.parameters.push({ module: module });
	}
}
